/** Fixed simulation timestep. 240 Hz divides evenly into 60/120/240 Hz displays. */
export const TICK_HZ = 240;
export const TICK_DT = 1 / TICK_HZ;

/** Maximum sim ticks executed per rendered frame (spiral-of-death guard). */
export const MAX_TICKS_PER_FRAME = 30;
